import { useUserQuery } from 'shared/hooks/queries/use-user-query';

export const useUser = () => {
  const { data } = useUserQuery();
  return data;
};
